import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'grid',
    alignContent: 'flex-start',
    gridGap: theme.spacing(4),
    position: 'relative',
    minHeight: '140px',
    paddingBottom: theme.spacing(6),
  },
  noNotifications: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
    width: '100%',
  },
}));

export default useStyles;
